import { Injectable } from '@angular/core';
import { ComponentCanDeactivate } from './component-can-deactivate';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class FormPendentGuard {

  constructor(private translateService: TranslateService) {}

  canDeactivate(component: ComponentCanDeactivate): boolean {

    if(!component.canDeactivate()){
      let text = this.translateService.instant('WARNINGS.cambios_pend');
        if (confirm(text)) {
            return true;
        } else {
            return false;
        }
    }
    return true;
  }
}
